"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellRating = void 0;
const react_1 = __importDefault(require("react"));
const emoji_1 = require("../../_private/emoji");
const styled_1 = require("./styled");
const CellRating = (props) => {
    const { field, count, className, style, cellClassName, cellStyle } = props;
    return (react_1.default.createElement(styled_1.RatingStyled, { className: className, style: style }, new Array(field.max).fill(null).map((_key, index) => (react_1.default.createElement(styled_1.RatingItemStyled, { key: index, checked: count ? index < count : false, className: cellClassName, style: cellStyle },
        react_1.default.createElement(emoji_1.Emoji, { emoji: field.icon, size: 16 }))))));
};
exports.CellRating = CellRating;
